const assignCardsToColumn = ({ columnId }, applications) => {
  const assignableCards = applications.filter(
    (application) => application.column === columnId
  );
  const assignableCardIds = assignableCards.map(({ id }) => id);
  return assignableCardIds;
};

const updateColumns = (columns, applications) =>
  columns.map((column) => ({
    ...column,
    cardIds: assignCardsToColumn(column, applications),
  }));

export default updateColumns;
